import { createBootstrap } from 'bootstrap-vue-next'
const bootstrap = createBootstrap();
export default bootstrap;
